import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'

const Header = () => {
  return (
    <>
      <Text align="center" semibold size="h5">
        Pedido de abertura de crédito de importação (IC)
      </Text>
      <Separator weight={10} />
    </>
  )
}

export default Header
